<template>
  <section>
    <EventsHeader />
    <EventsIndex />
    <!-- <EventsCta/> -->
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Events',
  components: { ...partials },
  metaInfo() {
    return {
      title: `${this.$t('common.navigation.allEvents')}`
    }
  }
}
</script>
